<template>
    <div class="d-flex flex-wrap p-0 col-11">
        <form-field :label="getFieldLabel('vaccineName')"
                    class="col-xs-12 col-sm-8 col-md-4 col-lg-3 p-0 mr-0 mr-sm-3 mt-3"
                    :value="object.vaccineName"
                    :editable="isEditable('vaccineName')"
                    :feedback="liveFeedback('vaccineName')">
            <template #field>
                    <b-input
                        id="vaccineName"
                        class="w-100"
                         v-model="$v.form.vaccineName.$model"
                        :state="validateState('vaccineName')">
                    </b-input>
            </template>
        </form-field>

        <form-field :label="getFieldLabel('vaccineAgainst')"
                    class="col-xs-12 col-sm-4 col-md-3 col-lg-2 p-0 mr-0 mr-sm-3 mt-3"
                    :value="object.vaccineAgainst"
                    :editable="isEditable('vaccineAgainst')"
                    :feedback="liveFeedback('vaccineAgainst')">
            <template #field>
                    <b-input
                        id="vaccineNumber"
                        class="w-100"
                         v-model="$v.form.vaccineAgainst.$model"
                        :state="validateState('vaccineAgainst')">
                    </b-input>
            </template>
        </form-field>

        <form-field :label="getFieldLabel('vaccineSeries')"
                    class="col-xs-12 col-sm-4 col-md-3 col-lg-2 p-0 mr-0 mr-sm-3 mt-3"
                    :value="object.vaccineSeries"
                    :editable="isEditable('vaccineSeries')"
                    :feedback="liveFeedback('vaccineSeries')">
            <template #field>
                    <b-input
                        id="vaccineSeries"
                        class="w-100"
                         v-model="$v.form.vaccineSeries.$model"
                        :state="validateState('vaccineSeries')">
                    </b-input>
            </template>
        </form-field>

        <form-field :label="getFieldLabel('vaccineNumber')"
                    class="col-xs-12 col-sm-4 col-md-3 col-lg-2 p-0 mr-0 mr-sm-3 mt-3"
                    :value="object.vaccineNumber"
                    :editable="isEditable('vaccineNumber')"
                    :feedback="liveFeedback('vaccineNumber')">
            <template #field>
                    <b-input
                        id="vaccineNumber"
                        class="w-100"
                         v-model="$v.form.vaccineNumber.$model"
                        :state="validateState('vaccineNumber')">
                    </b-input>
            </template>
        </form-field>

        <form-field :label="getFieldLabel('vetSpecialist')"
            class="col-xs-12 col-sm-8 col-md-6 col-lg-5 p-0 mr-0 mr-sm-3 mt-3"
            :value="object.vetSpecialist"
            :editable="isEditable('vetSpecialist')"
            :feedback="liveFeedback('vetSpecialist')">
            <template #field>
                    <b-input
                        id="vetSpecialist"
                        class="w-100"
                         v-model="$v.form.vetSpecialist.$model"
                        :state="validateState('vetSpecialist')">
                    </b-input>
            </template>
        </form-field>

        <form-field :label="getFieldLabel('conclusion')"
                    class="col-xs-12 col-sm-12 col-md-6 p-0 mr-3 mt-3"
                    :value="object.conclusion"
                    :editable="isEditable('conclusion')"
                    :feedback="liveFeedback('conclusion')">
            <template #field>
                    <b-form-textarea
                        id="conclusion"
                        class="w-100"
                        v-model="$v.form.conclusion.$model"
                        :state="validateState('conclusion')">
                    </b-form-textarea>
            </template>
        </form-field>

    </div>

</template>

<script>
    import FormField from "../../../../components/Forms/FormField";
    import {ObjectComponentMixin} from "../../../../components/Forms/ObjectComponentMixin";
    import { VaccinationEventAttributes } from "./vaccination";
    import {AttributeMixin} from "@/pages/AppPages/Events/AttributeMixin";

    export default {
        name: "VaccinationAttributes",
        components: { FormField },
        mixins: [ObjectComponentMixin, AttributeMixin],
        beforeMount() {
            this.objectClass = VaccinationEventAttributes;
            this.initialize();
        },
        mounted() {
            this.onMount();
            this.resetForm();
        },
    }
</script>

<style scoped>

</style>